import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

interface Props {
  error: Error | string;
  showReload?: boolean;
}

export default function ErrorDisplay({ error, showReload }: Props) {
  const message = error instanceof Error ? error.message : error;
  return (
    <Box>
      <Typography>{message}</Typography>
      {showReload && (
        <Button variant="contained" onClick={() => window.location.reload()}>Reload</Button>
      )}
    </Box>
  );
}
